module.exports = __webpack_public_path__ + "static/media/back_arrow.13999b0c.svg";